import { makeObservable, computed, reaction } from 'mobx';
import { BasicNodeModel, ComparisonNodeBaseModel } from '..';
import { ContractComparisonPanel } from '../../types';

export default class BasicComparisonNodeModel extends ComparisonNodeBaseModel {
    constructor(
        nodeId: string,
        nodeName: string,
        predefinedPanels?: ContractComparisonPanel[],
        readonly newNode?: BasicNodeModel,
        readonly previousNode?: BasicNodeModel
    ) {
        super(nodeId, nodeName, predefinedPanels);

        makeObservable(this, {
            inputIds: computed
        });

        this.initializeChangeTrackers();

        this.reactions.push(
            reaction(
                () => this.inputIds,
                () => this.initializeChangeTrackers()
            )
        );
    }

    initializeChangeTrackers() {
        this.contractChangeTracker.clearInputGroupChangeTrackers();

        this.panels.forEach(panel => {
            const inputGroupChangeTracker = this.contractChangeTracker.createInputGroupChangeTracker(
                panel.id,
                panel.name
            );

            panel.inputIds.forEach(inputId => {
                inputGroupChangeTracker.createInputChangeTracker(
                    inputId,
                    this.newNode?.getInputById(inputId),
                    this.previousNode?.getInputById(inputId)
                );
            });
        });
    }

    get inputIds() {
        return this.getInputIds(this.newNode?.inputIds, this.previousNode?.inputIds);
    }
}
